package app.nestbridge.domain.identity.model

import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
data class User(
    val id: String,
    val identityId: String,
    val emails: List<String> = emptyList(),
    val phoneNumbers: List<String> = emptyList(),
    val status: UserStatus,
    val createdAt: Instant,
    val createdBy: String,
    val modifiedAt: Instant,
    val modifiedBy: String,
) {
    companion object {
        val empty = User(
            id = "",
            identityId = "",
            emails = emptyList(),
            phoneNumbers = emptyList(),
            status = UserStatus.Active,
            createdAt = kotlin.time.Clock.System.now(),
            createdBy = "",
            modifiedAt = kotlin.time.Clock.System.now(),
            modifiedBy = "",
        )
    }
}

@Serializable
enum class UserStatus {
    Active,
    Suspended,
    Archived
}
